<template>
    <div id="search">
        <form id="filters" class="card shadow" v-on:submit.prevent="newSearch">
            <div class="card-body">
                <div class="form-row">
                    <div class="col-md-4">
                        <div class="form-row">
                            <div class="col-md-12 form-group">
                                <label class="form-label">
                                    Wanneer heeft u iemand nodig? <sup class="red">*</sup><br/>
                                    <small class="text-muted">Selecteer minimaal 1 datum.</small>
                                </label>
                                <multi-date-picker v-on:update="updateDates"></multi-date-picker>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 form-group">
                        <label class="form-label">
                            Welke vaardigheden zijn gewenst?<br/>
                            <small class="text-muted">Selecteer 0 of meerdere vaardigheden.</small>
                        </label>
                        <select class="form-control" v-model="selectedSkill" @change="addSkill" :disabled="isLoading || user.profileStatusId != 2">
                            <option value="-1" class="text-muted">Selecteer een vaardigheid...</option>
                            <optgroup>
                                <option :value="s" v-for="s in $store.getters.skills" :key="s.id" >{{s.description}}</option>
                            </optgroup>
                        </select>
                    </div>
                    <div class="col-md-4  form-group">
                        <label class="form-label">
                            In welke provincie(s) zoekt u?<br/>
                            <small class="text-muted">Selecteer 0 of meerdere specifieke provincies.</small>
                        </label>
                        <select class="form-control" v-model="selectedProvince" @change="addProvince" :disabled="isLoading || user.profileStatusId != 2">
                            <option value="-1" class="text-muted">Selecteer een provincie...</option>
                            <optgroup>
                                <option :value="p" v-for="p in $store.getters.provinces" :key="p.id">{{p.description}}</option>
                            </optgroup>
                        </select>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-6">
                        <!--
                        <div class="custom-control custom-checkbox mt-0">
                            <input class="custom-control-input" type="checkbox" value="" id="dateRange"  v-model="filters.dateRange" :disabled="isLoading" >
                            <label class="custom-control-label" for="dateRange">
                                Meerdere data?
                            </label>
                        </div>
                        -->
                        <div class="custom-control custom-checkbox mt-0">
                            <input class="custom-control-input" type="checkbox" value="" id="hasDog"  v-model="filters.hasDog" :disabled="isLoading || user.profileStatusId != 2"  @change="skip = 0">
                            <label class="custom-control-label" for="hasDog">
                                Beschikt over een hond?
                            </label>
                        </div>
                        <div class="custom-control custom-checkbox mt-0">
                            <input class="custom-control-input" type="checkbox" value="" id="hasDrivingLicence"  v-model="filters.hasDrivingLicence" :disabled="isLoading || user.profileStatusId != 2"  @change="skip = 0">
                            <label class="custom-control-label" for="hasDrivingLicence">
                                Heeft auto of motor rijbewijs?
                            </label>
                        </div>
                    </div>
                    <div class="col-6 text-right">
                        <button type="confirm" class="btn btn-half btn-outline-azure btn-lg"  :disabled="isLoading || user.profileStatusId != 2">
                            <span>Zoeken</span>
                            <div class="btn-icon">
                                <span>&rarr;</span>
                            </div>
                        </button>
                    </div>
                </div>
                <hr>
                <div class="form-row mt-3">
                    <div class="col-sm-4">
                        <h4>Regio filter:</h4>
                    </div>
                    <div class="col-sm-8">
                        <h4 v-if="filters.provinces.length == 0"><span class="badge badge-pill badge-secondary">Heel Nederland</span></h4>
                        <h4 v-else v-for="p in filters.provinces" :key="p.id" @click="removeProvince(p)"  class="badge-horizontal mr-2">
                            <span class="badge badge-pill badge-secondary clickable">{{p.description}}<font-awesome-icon icon="times" class="ml-2 light-red"></font-awesome-icon></span>
                        </h4>
                    </div>
                </div>
                <div class="form-row mt-0" v-if="filters.skills.length > 0">
                    <div class="col-sm-4">
                        <h4>Vaardigheden filter:</h4>
                    </div>
                    <div class="col-sm-8">
                        <h4 v-for="p in filters.skills" :key="p.id" @click="removeSkill(p)" class="badge-horizontal mr-2">
                            <span class="badge badge-pill badge-secondary clickable">{{p.description}}<font-awesome-icon icon="times" class="ml-2 light-red"></font-awesome-icon></span>
                        </h4>
                    </div>
                </div>
            </div>
        </form>
        <hr>
        <h3>Zoek Resultaten</h3>
        <div class="text-center" v-if="isLoading">
            <loader width="5rem"></loader>
        </div>
        <div v-else-if="results.length == 0 && user.profileStatusId == 2" class="text-center mt-5 mb-5">
            <h2>Geen professionals gevonden?<br><small class="light">Pas de zoek filters aan en probeer opnieuw.<br>of</small></h2>
            <button id="assignmentModalBtn" class="btn btn-azure-dark btn-lg" @click="showAssignmentModal = true">Plaats een opdracht</button>
        </div>

        <ul class="list-group mb-3 shadow" v-else-if="user.profileStatusId == 2">
            <li class="list-group-item" v-for="r in results" :key="r.id">
                <div class="row">
                    <div class="col-md-2 text-center vert-center" v-if="!!r.profileImage">
                        <img :src="'data:' + r.profileImage.fileContentType + ';base64,' + r.profileImage.file" class="img-fluid img-thumbnail rounded-circle img-profile mx-auto" />
                    </div>
                    <div class="col-md-6">
                        <h4>
                            <img src="@/assets/no_security_30.png" class="mr-3" v-if="!r.isSecurity" title="Geen Beveiliger" alt="Geen Beveiliger" height="25" width="25" />
                            <router-link tag="a" to="">
                                <span @click="viewReviewModal(r)">{{r.firstName}}</span>
                            </router-link>
                            <small class="text-muted ml-2" v-if="r.contractId == 1">(zzp)</small>
                            <small class="text-muted ml-2" v-if="r.contractId == 2">(Azurity)</small>
                            <small class="text-muted ml-2" v-if="r.contractId == 3">(via werkgever)</small>
                        </h4>
                        <p class="profileText" :alt="r.description" :title="r.description">
                            <span v-html="r.description"></span>
                        </p>
                        <div class="mb-2 row">
                            <div class="col-md-4">
                                <strong>Vaardigheden:</strong>
                            </div>
                            <div class="col-md-8">
                                <span class="badge badge-pill badge-secondary mr-1" v-for="s in r.skills" :key="s.id">{{s.description}}</span>
                            </div>
                        </div>
                        <div class="mb-2 row">
                            <div class="col-md-4">
                                <strong>Werkgebied(en):</strong>
                            </div>
                            <div class="col-md-8">
                                <span class="badge badge-pill badge-secondary mr-1" v-for="p in r.provinces" :key="p.id">{{p.description}}</span>
                            </div>
                        </div>
                        <div class="mb-2 row">
                            <div class="col-md-4">
                                <strong>Beschikbaarheid:</strong>
                            </div>
                            <div class="col-md-8">
                                <span v-for="(p, index) in filters.dates" :key="index">
                                    <span class="badge badge-pill badge-secondary mr-1" v-if="r.availableDates.some((c) => { return new Date(c).getTime() == p.getTime() })" >{{new Date(p).toLocaleDateString()}}</span>
                                    <span class="badge badge-pill badge-danger mr-1" v-else >{{new Date(p).toLocaleDateString()}}</span>
                                </span>
                            </div>
                        </div>
                        <div class="badges text-left">
                            <font-awesome-icon icon="dog" title="Hond" class="m-2" v-if="r.hasDog" />
                            <font-awesome-icon icon="motorcycle" title="Motorrijbewijs (A)" class="m-2" v-if="r.rijbewijsA" />
                            <font-awesome-icon icon="car" title="Autorijbewijs (B)" class="m-2" v-if="r.rijbewijsB" />
                            <font-awesome-icon icon="truck" title="Vrachtwagenrijbewijs (C)" class="m-2" v-if="r.rijbewijsC" />
                            <font-awesome-icon icon="bus" title="Busrijbewijs (D)" class="m-2" v-if="r.rijbewijsD" />
                        </div>
                    </div>
                    <div class="col-md-4 text-right pt-3">
                        <div clas="block mb-5">
                            <h3 class="inline mb-0"><small>v.a.</small> € {{r.dayRate.toFixed(2)}}<sup>*</sup></h3>
                            <br />
                            <small> per uur (excl.BTW) </small>
                            <!--<font-awesome-icon icon="info-circle" class="rate-info" v-tooltip.top-end="'Dagtarief: € ' + r.dayRate.toFixed(2) + '<br>Avondtarief: € ' + r.eveningRate.toFixed(2) + '<br>Nachttarief: € ' + r.nightRate.toFixed(2) + '<br>Weekendtarief: € ' + r.weekendRate.toFixed(2) + '<br>Hond Toeslag: € ' + r.dogRate.toFixed(2) + '<br><small>Tarieven zijn een schatting.</small>'" title="tarieven" />-->
                            <font-awesome-icon icon="info-circle" class="rate-info" title="tarieven" />
                        </div>
                        <button class="btn btn-outline-azure-dark mt-3 mr-3" type="submit" @click="$emit('add', r)">Selecteren</button>
                        <button class="btn mt-3 btn-azure" type="submit" @click="requestProfessional(r)">Direct Aanvragen</button><br>
                        <div @click="viewReviewModal(r)">
                            <score :score="r.rating" :disabled="true" class="mt-3" :qty="r.reviewCount" ></score>
                        </div>
                    </div>
                </div>
            </li>
            <li class="list-group-item text-center" v-if="showLoadMore">
                <button class="btn btn-outline-azure btn-half text-center" @click="skip += 10">Meer laden >>></button>
            </li>
        </ul>
        
        <div class="text-center mt-5" v-else>
            <h3>Uw account wacht nog op goedkeuring!</h3>
        </div>

        <assignment-modal :professionals="selectedProfessional" :show="showAssignmentModal" @close="closeAssignmentModal"></assignment-modal>
        <vue-toastr ref="toastr"></vue-toastr>
        <modal v-if="showReviews" @close="showReviews = false; reviews = []">
            <h4 slot="header" class="m-0">Reviews</h4>
            <div slot="body">
                <div class="text-center" v-if="isLoadingReviews">
                    <loader width="3rem"></loader>
                </div>
                <div class="text-center" v-else-if="reviews.length == 0">
                    <h5 class="text-muted">Nog geen reviews...</h5>
                </div>
                <ul class="list-group" v-else>
                    <li class="list-group-item" v-for="r in reviews" :key="r.id">
                            <div class="d-flex w-100 justify-content-between">
                                <h5 class="mb-1">{{r.company}}</h5>
                                <small>{{new Date(r.date).toLocaleDateString()}}</small>
                            </div>
                            <div class="d-flex w-100 justify-content-between mt-2">
                                <p class="m-0 mr-3" v-html="r.publicReview"></p>
                                <score class="" :score="r.rating" :showQty="false" :disabled="true"></score>
                            </div>
                    </li>
                </ul> 
            </div>
        </modal>
    </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength, integer, minValue } from 'vuelidate/lib/validators'

import VueToastr from "vue-toastr";
import Score from '@/components/Score';
import Loader from '@/components/Loader';
import Modal from '@/components/Modal';
import AssignmentModal from '@/components/AssignmentModal';
import MultiDatePicker from '@/components/MultiDatePicker';

export default {
    name: 'search',
    mixins: [validationMixin],
    components: {
        Score,
        Loader,
        AssignmentModal,
        MultiDatePicker,
        VueToastr,
        Modal
    },
    data() {
        return {
            isLoading: false,
            isLoadingReviews: false,
            showReviews: false,
            showLoadMore: true,
            skip: 0,
            selectedSkill: -1,
            selectedProvince: -1,
            results: [],
            reviews: [],
            showAssignmentModal: false,
            selectedProfessional: [],
            filters: {
                dates: [],
                skills: [],
                provinces: [],
                dateRange: false,
                hasDog: false,
                hasDrivingLicence: false
            },
        }
    },
    validations: {
    },
    methods: {
        addSkill() {
            this.skip = 0;
            const skill = this.selectedSkill;
            if(this.filters.skills.indexOf(skill) < 0 && !this.isLoading)
            {
                this.filters.skills.push(skill);
                this.$refs.toastr.s("Filter " + skill.description + " is toegevoegd!");
            }
            this.selectedSkill = -1;
        },
        removeSkill(skill) {
            this.skip = 0;
            if(this.filters.skills.indexOf(skill) >= 0 && !this.isLoading)
                this.filters.skills.splice(this.filters.skills.indexOf(skill), 1);
        },
        addProvince() {
            this.skip = 0;
            const province = this.selectedProvince;
            if(this.filters.provinces.indexOf(province) < 0 && !this.isLoading)
            {
                this.filters.provinces.push(province);
                this.$refs.toastr.s("Filter " + province.description + " is toegevoegd!");
            }
            this.selectedProvince = -1;
        },
        removeProvince(province) {
            this.skip = 0;
            if(this.filters.provinces.indexOf(province) >= 0 && !this.isLoading)
                this.filters.provinces.splice(this.filters.skills.indexOf(province), 1);
        },
        newSearch() {
            this.skip = 0;
            this.search();
        },
        search() {
            if(!this.isLoading)
            {
                this.isLoading = true;
                this.$http.post('api/Search/Professionals?skip=' + this.skip, this.filters).then((res) => {
                    this.isLoading = false;
                    if(res.data.length < 10)
                        this.showLoadMore = false;

                    if(this.skip == 0) {
                        this.results = res.data;
                    } else {
                        res.data.forEach((r) => {
                            this.results.push(r);
                        });
                    }

                    if(this.results.length == 0)
                    {
                        this.$refs.toastr.e("Geen professionals gevonden...");

                        const card = document.getElementById('filters');
                        this.timeout(250, () => { 
                            card.classList.toggle('border-dark');
                        }, 5);
                    }
                }).catch(() => {
                    this.isLoading = false;
                    const card = document.getElementById('filters');
                    this.timeout(250, () => { 
                        card.classList.toggle('border-dark') 
                    }, 5);
                })
            }
        },
        timeout(interval, cb, loop) {
            setTimeout(() => {
                cb();
                if(loop > 0)
                    this.timeout(interval, cb, loop - 1);
            }, interval);
        },
        requestProfessional(p) {
            this.selectedProfessional = [p];
            this.showAssignmentModal = true;
        },
        closeAssignmentModal() {
            this.showAssignmentModal = false;
            this.selectedProfessional = [];
        },
        updateDates(dates) {
            return this.filters.dates = dates.map(d => { return new Date(d.getTime() - (d.getTimezoneOffset() * 60 * 1000)) });
        },
        viewReviewModal(user) {
            this.showReviews = true;
            this.isLoadingReviews = true;
            this.$http.get('api/Review/Public/' + user.applicationUserId).then((res) => {
                this.reviews = res.data;
                this.isLoadingReviews = false;
            }).catch(() => {
                this.showReviews = false;
                this.isLoadingReviews = false;
            })
        }
    },
    mounted() {
        this.$store.dispatch("GET_SKILLS");
        this.$store.dispatch("GET_PROVINCES");
        
        this.$refs.toastr.defaultPosition = "toast-bottom-right";
        
        const today = new Date();
        const dateString = today.getFullYear() + '-' + ("0" + (today.getMonth() + 1)).slice(-2) + '-' + ("0" + (today.getDate())).slice(-2);
        
        this.filters.startDate = dateString;
        this.filters.endDate = dateString;
    },
    computed: {
        today() {
            const today = new Date();
            return today.getFullYear() + '-' + today.getMonth() + '-' + today.getDay();
        },
        user() {
            return this.$store.getters.user;
        }
    },
    watch: {
        filters: {
            handler(to) {
                this.$emit('filters', to);
            },
            deep: true
        },
        skip(value) {
            this.search();
        }
    }
}
</script>

<style scoped lang="scss">
.card {
    background-color: $lightColor;
}

@media only screen and (min-width: 768px) {
    .form-row {
        height: 100%;
        .form-group {
            height: 100%;
            div {
                position: absolute;
                bottom:0;
                left:0;
                margin-bottom: 15px;
                width:100%;
                padding-right: 5px;
                padding-left: 5px;
            }
        }
    }
}
.form-label {
    font-weight: bold;
}
.badge.clickable {
    cursor: pointer;
}

img {
    max-height: 120px;
}
.profileText {
    //white-space: nowrap; 
    //overflow: hidden;
    //text-overflow: ellipsis;
    //-ms-text-overflow: ellipsis;
    //-o-text-overflow: ellipsis;
}
.badge-horizontal {
    display: inline-block;
}
.badge-danger {
    text-decoration: line-through;
}
.light {
    color: $lightColor;
}
.block {
    display: block;
}
.inline {
    display: inline-block;
}
.rate-info
{
    cursor: pointer;
}

.light-red 
{
    color: darkred;
    opacity: 0.3;
}

.light-red:hover {
    opacity: 1;
}
</style>
